import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import trap from '@alpinejs/trap';
import Tooltip from '@ryangjchandler/alpine-tooltip';
import Scroll from '@alpine-collective/toolkit-scroll';
import Clipboard from '@ryangjchandler/alpine-clipboard';

Alpine.plugin(intersect);
Alpine.plugin(trap);
Alpine.plugin(Tooltip);
Alpine.plugin(Scroll);
Alpine.plugin(Clipboard);

Alpine.store('lightbox', {
  display: false,
  images: {},
  imageIndex: null,
});

window.Alpine = Alpine;

Alpine.start();
